import type { ExportFormat } from '../../types/export';
import { EXPORT_FORMAT_FILE_EXTENSIONS } from '../../constants/export';

/**
 * Generates a default filename for export.
 */
export function getDefaultFilename(tableName: string | undefined, format: ExportFormat): string {
  const prefix = tableName ?? 'export';
  const date = new Date().toISOString().split('T')[0];
  const extension = EXPORT_FORMAT_FILE_EXTENSIONS[format];

  return `${prefix}-${date}.${extension}`;
}
